'use client'
import { useState } from 'react'
import { Star } from 'lucide-react'

export default function FeedbackPage() {
  const [rating, setRating] = useState(0)
  const [hoveredRating, setHoveredRating] = useState(0)
  const [submitted, setSubmitted] = useState(false)

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    setSubmitted(true)
  }

  if (submitted) {
    return (
      <div className="min-h-screen pt-24 pb-12 px-4 flex items-center justify-center">
        <div className="glass-panel p-8 text-center max-w-md">
          <div className="text-5xl mb-4">🎉</div>
          <h2 className="text-2xl font-bold text-white mb-2">Thank You!</h2>
          <p className="text-zinc-400">Your feedback helps us improve. We appreciate your time!</p>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen pt-24 pb-12 px-4">
      <div className="container max-w-lg mx-auto">
        <h1 className="text-2xl md:text-3xl font-black text-white mb-4">Feedback</h1>
        <p className="text-zinc-400 text-sm mb-4">We'd love to hear your thoughts on how we can improve.</p>

        <form onSubmit={handleSubmit} className="compact-form glass-panel p-3 sm:p-4 space-y-2">
          {/* Rating */}
          <div>
            <label className="block text-xs text-zinc-400 mb-1">How would you rate your experience?</label>
            <div className="flex gap-2">
              {[1, 2, 3, 4, 5].map((star) => (
                <button
                  key={star}
                  type="button"
                  onClick={() => setRating(star)}
                  onMouseEnter={() => setHoveredRating(star)}
                  onMouseLeave={() => setHoveredRating(0)}
                  className="p-1"
                >
                  <Star 
                    className={`w-6 h-6 transition-colors ${
                      star <= (hoveredRating || rating) 
                        ? 'fill-yellow-400 text-yellow-400' 
                        : 'text-zinc-600'
                    }`} 
                  />
                </button>
              ))}
            </div>
          </div>

          {/* Category */}
          <div>
            <label className="block text-xs text-zinc-400 mb-1">What's your feedback about?</label>
            <select className="input-field">
              <option value="">Select a category</option>
              <option value="feature">Feature Request</option>
              <option value="bug">Bug Report</option>
              <option value="design">Design/UI</option>
              <option value="other">Other</option>
            </select>
          </div>

          {/* Message */}
          <div>
            <label className="block text-xs text-zinc-400 mb-1">Your Feedback</label>
            <textarea 
              placeholder="Tell us what you think..." 
              rows={3} 
              className="input-field resize-y" 
              required 
            />
          </div>

          {/* Email (optional) */}
          <div>
            <label className="block text-xs text-zinc-400 mb-1">Email (optional)</label>
            <input type="email" placeholder="your@email.com" className="input-field" />
            <p className="text-xs text-zinc-600 mt-1">In case we need to follow up with you.</p>
          </div>

          <button type="submit" className="btn btn-primary w-full">
            Submit Feedback
          </button>
        </form>
      </div>
    </div>
  )
}
